import { useEffect } from 'react';
import DataTable from 'react-data-table-component';
import Spinner from 'react-bootstrap/Spinner';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { fetchCharacterClassApi } from './characterClassSlice';

const columns = [
    {
        name: '#',
        selector: (row) => row.id,
    },
    {
        name: 'Character class',
        selector: (row) => row.characterClass,
        sortable: true,
    },
    {
        name: 'Picked %',
        selector: (row) => row.picked,
        sortable: true,
    },
    {
        name: 'Won %',
        selector: (row) => row.won,
        sortable: true,
    },
];

const customStyles = {
    headCells: {
        style: {
            fontWeight: 'bold', // override the cell padding for head cells
        },
    },
};

function CharacterClass() {
    const { rows } = useSelector((state) => state.dashboard.characterClass);
    const { isLoading } = useSelector((state) => state.loading);
    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        if (rows.length > 0) return;
        dispatch(fetchCharacterClassApi(navigate));
    }, []);

    return (
        <div className="col-sm-12">
            <DataTable
                columns={columns}
                data={rows}
                striped
                pagination
                paginationPerPage="10"
                persistTableHead
                progressPending={isLoading} //spinning icon will trigger when isLoading = 1
                noDataComponent={<h3 className="m-3">No data...</h3>}
                progressComponent={
                    <Spinner
                        animation="border"
                        role="status"
                    >
                        <span className="visually-hidden"></span>
                    </Spinner>
                }
                customStyles={customStyles}
            />
        </div>
    );
}
//ref: https://codesandbox.io/s/gws1i?file=/src/App.js (datatable with filtering)
export default CharacterClass;
